"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CareerInfoRendererCms = void 0;
var CareerInfoRendererCms = /** @class */ (function () {
    function CareerInfoRendererCms() {
        this.transferNumberLabel = 'Transfer number: ';
        this.editCTALabel = 'Edit';
        this.linkAriaLabel = 'Edit transfer number';
    }
    return CareerInfoRendererCms;
}());
exports.CareerInfoRendererCms = CareerInfoRendererCms;
//# sourceMappingURL=CareerInfoRenderer.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeviceOptionsPanel/DeviceCard/ExpandedFormOptions/TransferForm/CareerInfoRenderer/CareerInfoRenderer.cms.js
// module id = 2002
// module chunks = 8